import { render, staticRenderFns } from "./SettingsItem.vue?vue&type=template&id=b907d792&scoped=true&"
import script from "./SettingsItem.vue?vue&type=script&lang=js&"
export * from "./SettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./SettingsItem.vue?vue&type=style&index=0&id=b907d792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b907d792",
  null
  
)

export default component.exports